module.exports = __webpack_public_path__ + "static/img/faq-header.8b4432d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/faq-header.jpg
// module id = BzMf
// module chunks = 0